import React from 'react';
import useUserLeavingApp from '../hooks/useUserLeavingApp';

const withUserLeavingApp = (Component) => (props) => {
  const [isUserLeavingApp, noAttemptsToLeave] = useUserLeavingApp();
  return (
    <Component
      {...props}
      isUserLeaving={isUserLeavingApp}
      noAttemptsToLeave={noAttemptsToLeave}
    />
  );
};

export default withUserLeavingApp;
